const DealershipStyle = {
  noBorder: {
    border: "none",
    padding: "0px 16px 0px 16px",
    textAlign: "center",
  },
  dealerBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // m: 1,
    overflow: "hidden",
  },
  dealerButton: { height: "40px", alignSelf: "flex-end", marginRight: "16px" },
  wrapper: {
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "16px",
    marginY: "16px",
    maxWidth: "100%",
  },
  papers: {
    width: "15%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "2px 15px 3px 3px",
    // boxShadow:
    //   "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    boxShadow: "none",
    overflow: "hidden",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    // p: 1,
  },
  detailPaper: {
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    maxHeight:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
          ? "80vh"
          : window.innerHeight >= 900
            ? "80vh"
            : "75vh",
    height:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
          ? "80vh"
          : window.innerHeight >= 900
            ? "80vh"
            : "75vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  rightDetailPaper: {
    padding: "16px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    height:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
          ? "80vh"
          : window.innerHeight >= 900
            ? "80vh"
            : "75vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  detailBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  detailFirstBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    padding: "6px",
  },
  detailSecondBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "4px",
    borderRadius: "6px",
    backgroundColor: "#e8f4ea",
    gap: "4px",
    cursor: "pointer",
  },
  iconButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    padding: "6px",
  },
  logoBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  personIcon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "16px",
    gap: "4px",
  },
  statusBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "4px",
    borderRadius: "6px",
    gap: "4px",
    width: "fit-content",
    margin: "auto",
  },
  emailIcon: {
    gap: "16px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  phoneIcon: {
    gap: "16px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginTop: "16px",
  },
  pullCount: {
    display: "flex",
    justifyContent: "space-between",
  },
  detailButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  userTable: { border: "none" },

  tableRow: {
    padding: "16px",
    border: "none",
    color: "#00ab55",
    cursor: "pointer",
  },
  title: {
    paddingTop: "16px",
    paddingLeft: "16px",
    fontWeight: "bold",
  },
  breadcrumbWrapper: {
    paddingLeft: "16px",
    paddingTop: "16px",
    border: "none",
  },
  tableWrapper: {
    margin: "16px",
    marginTop: "24px",
    height: 600,
    border: "none",
    boxShadow: "none",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableCell: {
    color: "#303131",
    border: "none",
    background: "#F4F6F8",
    fontWeight: "bold",
    textAlign: "center",
    // paddingX: "8px",
  },
  detailTableCell: { padding: "16px", border: "none" },
  cardWrapper: {
    display: { xs: "block", md: "flex" },
    marginX: "8px",
  },
  cardComponent: {
    flex: 1,
  },
  chartComponent: {
    flex: 1,
    display: "flex",
  },
  card: {
    margin: "8px",
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
  },
  chart: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    flexDirection: "column",
  },
  verifyButton: { flex: 1, m: 1, marginTop: "16px" },
  qrButton: { flex: 1, m: 1 },
  box: {
    flex: 1,
    display: "flex",
  },
  paper: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    flexDirection: "column",
  },
  countWrapper: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    height: "100%",
  },
  count: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  heading: { paddingLeft: "8px", fontWeight: "bold" },
  icon: {
    paddingRight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  noValidate: {
    padding: "16px",
    gap: "20px",
    display: { xs: "block", md: "flex" },
  },
  filter: {
    display: { xs: "flex" },
    mb: { xs: "16px", sm: "auto" },
    width: "100%",
  },
  textField: {
    display: { xs: "flex" },
    mb: { xs: "16px", sm: "auto" },
  },
  customerName: {
    flex: 1,
    display: { xs: "flex" },
  },
  customerUser: {
    "&:hover": {
      backgroundColor: "rgba(0,171,85,0.05)",
      cursor: "default",
      "& > *": {
        // color: theme.palette.primary.main,
      },
    },
  },
  insuranceCarrier: {
    border: "none",
    color: "#00ab55",
    cursor: "pointer",
  },
  sideTabOutsideBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    flexDirection: "column",
  },
  leftsideTab: {
    width: "100%",
    border: 1,
    borderColor: "divider",
    justifyContent: "flex-start",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    p: 1,
  },
  editPaper: {
    display: "flex",
    flexDirection: "column",
    // padding: "16px",
    backgroundColor: "#fff",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    // overflow: "scroll",
    height: "70vh",
    margin: "2px 15px 3px 3px",
  },
  editTabOutsideBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    flexDirection: "row",
  },
  editleftsideTab: {
    width: "100%",
    // border: 1,
    borderColor: "divider",
    justifyContent: "flex-start",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    p: "10px 0px 10px 0px",
    borderRadius: "10px",
    backgroundColor: "#fafafa",
    height: "10%",
    // backgroundColor: "#f2f2f2",
    // boxShadow:
    //   "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
  },

  tablePaper: {
    width: "73%", overflow: "scroll", height: "100%",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    maxHeight:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
          ? "80vh"
          : window.innerHeight >= 900
            ? "80vh"
            : "75vh",
    height:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
          ? "80vh"
          : window.innerHeight >= 900
            ? "80vh"
            : "75vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableCellStyle: {
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "10ch",
    border: "none",
  }


};
export default DealershipStyle;
